import React from 'react';
import PropTypes from 'prop-types';

const LinkedAccountCell = ({ dataKey, data, openLinkedAccountModal }) => <React.Fragment>
  { data && data[dataKey] != null && data[dataKey] > 0 && <button
    className="btn btn-secondary"
    type="button"
    onClick={ () => openLinkedAccountModal(data.accountId) }
  >
    { `${ data[dataKey] }` }
  </button> }
  { data && data[dataKey] != null && data[dataKey] === 0 && <button
    className="btn "
    disabled
    type="button"
  >
    { `${ data[dataKey] }` }
  </button> }
  { (!data || !data[dataKey] == null || data[dataKey] < 0) && 'N/A' }
</React.Fragment>;

LinkedAccountCell.propTypes = {
  dataKey: PropTypes.string,
  data: PropTypes.shape(),
  openLinkedAccountModal: PropTypes.func.isRequired
};

LinkedAccountCell.defaultProps = {
  dataKey: null,
  data: null,
};

export default LinkedAccountCell;
